import { useEffect } from 'react';
import { object, string, func } from 'prop-types';
import { Row, Col, Input, Text, Image, Paragraph, message } from 'antd/index';
import moment from 'moment';
import copy from '../../../assets/icons/copy-icon.svg';
import CustomButton from 'components/CustomButton/CustomButton';
import {
  SEND_EMAIL_WITH_GENERATED_TEST_LINK_MESSAGES,
  GENERATE_TEST,
  BUTTON_TEXTS,
  STORAGE_PATH,
} from 'constants/index';

const { INFO } = SEND_EMAIL_WITH_GENERATED_TEST_LINK_MESSAGES;
const { GENERATED_TEST, CANDIDATE, EXPIRE, LINK, COPY_LINK } = GENERATE_TEST;
const { CLOSE } = BUTTON_TEXTS;

const GeneratedTestFormUI = ({ form, idGenerated, copyToClipboard, copiedWord, setIsModalGeneratedTestVisible }) => {
  useEffect(() => message.info(INFO), []);

  return (
    <Col className="generated-test-content">
      <Row className="generated-test-content__title">{GENERATED_TEST}</Row>
      <Row className="generated-test-content-test">
        <Col className="generated-test-content-test-info">
          {CANDIDATE}
          <Text className="generated-test-content-test-info-text">{form.getFieldValue('recruitedPerson')}</Text>
        </Col>
        <Col className="generated-test-content-test-info date">
          {EXPIRE}
          <Paragraph className="generated-test-content-test-info-text">
            <Text className="generated-test-content-test-info-text-day">
              {moment(form.getFieldValue('expireTime')).format('DD.MM.YYYY')}
            </Text>
            <Text className="generated-test-content-test-info-text-hour">
              {moment(form.getFieldValue('expireTime')).format('HH:mm')}
            </Text>
          </Paragraph>
        </Col>
      </Row>
      {/*
      commented according to BB-826
      <Row className="generated-test-content-show-result">
        <Checkbox disabled checked={form.getFieldValue('resultCondition')} />
        Pokaż wynik kandydatowi
      </Row> */}
      <Row>
        <Col className="generated-test-content__link">
          {LINK}
          <Input
            className="generated-test-content__link-text"
            ref={copiedWord}
            value={
              window.location.protocol == 'http:'
                ? `http://${window.location.hostname}:${window.location.port}/${STORAGE_PATH.TEST_TO_SOLVE}/${idGenerated}`
                : window.location.protocol == 'https:'
                ? `https://${window.location.hostname}:${window.location.port}/${STORAGE_PATH.TEST_TO_SOLVE}/${idGenerated}`
                : `${window.location.hostname}:${window.location.port}/${STORAGE_PATH.TEST_TO_SOLVE}/${idGenerated}`
            }
          />
        </Col>
      </Row>
      <Row className="generated-test-content__buttons">
        <Col>
          <Row>
            <CustomButton className="custom-button--resign" onClick={() => setIsModalGeneratedTestVisible(false)}>
              {CLOSE}
            </CustomButton>
          </Row>
        </Col>
        <Col>
          <Row>
            <CustomButton
              className="custom-button--submit copy"
              onClick={evt => {
                copyToClipboard(evt);
              }}
            >
              <Image className="icon" preview={false} src={copy} />
              {COPY_LINK}
            </CustomButton>
          </Row>
        </Col>
      </Row>
    </Col>
  );
};

GeneratedTestFormUI.propTypes = {
  form: object,
  title: string,
  copyToClipboard: func,
  idGenerated: string,
  copiedWord: object,
  history: object,
  setIsModalGeneratedTestVisible: func,
};

export default GeneratedTestFormUI;
